import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  CONTROL_PLANE_SECTION,
  GUESSWORK_SECTION,
  LANDING_HERO,
  LANDING_PRICING_CARDS,
  LANDING_VALUE_CARDS,
  READY_TO_STOP_GUESSING_SECTION,
} from '../../constants/landing-page-content';
import { LandingFeatureSection } from '../../components/landing-feature-section/landing-feature-section';
import { LandingHero } from '../../components/landing-hero/landing-hero';
import { PricingCard } from '../../components/pricing-card/pricing-card';
import { ValueCard } from '../../components/value-card/value-card';

@Component({
  selector: 'app-landing',
  imports: [LandingFeatureSection, LandingHero, PricingCard, ValueCard],
  templateUrl: './landing.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Landing {
  protected readonly hero = LANDING_HERO;
  protected readonly guessworkSection = GUESSWORK_SECTION;
  protected readonly controlPlaneSection = CONTROL_PLANE_SECTION;
  protected readonly readyToStopGuessingSection = READY_TO_STOP_GUESSING_SECTION;
  protected readonly pricingCards = LANDING_PRICING_CARDS;
  protected readonly valueCards = LANDING_VALUE_CARDS;
}
